module.exports = __webpack_public_path__ + "static/media/onboard-step-4.3230c50b.png";